import { ChangeEvent, FC, useState, useEffect } from 'react';
import { TableInstance } from 'react-table';
import { Flex, Text, Select, IconButton } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useTranslation } from 'helpers/languages/translations';
import { paginationContainerStyle } from '../styles';

const TablePagination: FC<{ tableInstance: TableInstance<object>; pageSize?: number }> = ({
    tableInstance,
    pageSize,
}) => {
    const {
        canNextPage,
        canPreviousPage,
        pageCount,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex },
    } = tableInstance;
    const translate = useTranslation();
    const [currentPageSize, setCurrentPageSize] = useState('15');

    useEffect(() => {
        if (!pageSize) tableInstance.setPageSize(15);
    }, []);

    const handleChangeSelect = (event: ChangeEvent<HTMLSelectElement>) => {
        setPageSize(Number(event.target.value));
        setCurrentPageSize(event.target.value);
    };

    return (
        <Flex {...paginationContainerStyle}>
            <Flex alignItems="center">
                <Text color="gray.700" fontSize="sm" flexShrink="0" mr="8px">
                    {translate('table.footer.page_number')}
                </Text>
                <Select value={pageSize || currentPageSize} size="sm" minW="75px" onChange={handleChangeSelect}>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                </Select>
            </Flex>
            <Flex alignItems="center">
                <Text color="gray.700" fontSize="sm" mr="8px">{`page ${pageIndex + 1} of ${pageCount}`}</Text>
                <Flex>
                    <IconButton
                        onClick={() => previousPage()}
                        disabled={!canPreviousPage}
                        aria-label="back pagination"
                        variant="unstyled"
                        icon={<ChevronLeftIcon />}
                    />
                    <IconButton
                        onClick={() => nextPage()}
                        disabled={!canNextPage}
                        aria-label="next pagination"
                        variant="unstyled"
                        icon={<ChevronRightIcon />}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};

export default TablePagination;
